const PROFILE_SCOPES = {
  min: ["audio:process", "min:read", "min:write"],
  whatsapp: ["chats:read", "chats:write", "contacts:read"],
};

export const MCP_PERMISSION_GROUPS = [
  { id: "readWhatsapp", scopes: ["chats:read", "contacts:read", "groups:read", "profile:read"] },
  { id: "writeWhatsapp", scopes: ["chats:write", "groups:write"] },
  { id: "readStatuses", scopes: ["statuses:read"] },
  { id: "writeStatuses", scopes: ["statuses:write"] },
  { id: "readKeys", scopes: ["api_keys:read"] },
  { id: "manageKeys", scopes: ["api_keys:manage"] },
];
const UNIFIED_SCOPES = [...PROFILE_SCOPES.min, ...MCP_PERMISSION_GROUPS.flatMap((group) => group.scopes)].sort();

export function mcpNeedsNumbers(scopes = []) {
  return scopes.some((scope) => /^(chats|contacts|groups|statuses|profile):/.test(scope));
}

export function toggleMcpPermissions(scopes, group, checked) {
  const requested = new Set(scopes);
  for (const scope of group.scopes) checked ? requested.add(scope) : requested.delete(scope);
  return [...requested];
}

export function isMinAgentReturnPath(value = "") {
  const path = String(value || "");
  if (!path.startsWith("/") || path.startsWith("//") || path.includes("\\")) return false;
  const pathname = path.split(/[?#]/)[0];
  if (/^\/agent\/(?:(?:upstream-)?authorize|setup)\/?$/.test(pathname)) return true;
  const artifact = /^\/agent\/(?:keys|media)\/([A-Za-z0-9_.~=-]+)\/?$/.exec(pathname);
  return Boolean(artifact && ![".", ".."].includes(artifact[1]));
}

export function mcpConsentProfile(payload) {
  if (payload?.grant_profile === "unified") {
    const scopes = payload.scopes;
    return payload.grant_version === 2 && Array.isArray(scopes) && scopes.length === UNIFIED_SCOPES.length
      && [...scopes].sort().every((scope, index) => scope === UNIFIED_SCOPES[index])
      && Array.isArray(payload.default_scopes) && payload.default_scopes.length === PROFILE_SCOPES.min.length
      && [...payload.default_scopes].sort().every((scope, index) => scope === PROFILE_SCOPES.min[index])
      && payload.account_scope === "selected" ? "unified" : "";
  }
  const expected = PROFILE_SCOPES[payload?.grant_profile];
  const scopes = payload?.scopes;
  return expected && Array.isArray(scopes) && scopes.length === expected.length
    && [...scopes].sort().every((scope, index) => scope === expected[index]) ? payload.grant_profile : "";
}

export function findVerifiedLinkedAccount(accounts, { accountId = "", previousWorkingIds = [] } = {}) {
  return (Array.isArray(accounts) ? accounts : []).find((account) => account?.id && account.status === "WORKING"
    && (accountId ? account.id === accountId : !previousWorkingIds.includes(account.id))) || null;
}
